import { Badge } from "@/components/ui/badge";
import { barisButir, ringkasDimensi, LABEL_STATUS_VERSI } from "@/lib/surveiVersi";
import { OPSI_TB_BAWAAN } from "@/lib/surveiEditor";

// Isi SATU versi butir (baca-saja): ringkasan dimensi, tabel butir (nomor, dimensi, teks, tanda kalimat negatif), dua
// isian terbuka, skala & ambang. Tanpa logika peran & tanpa API -- PR #108 menambah mode edit di komponen ini.
export default function SurveiIsiVersi({ versi }) {
    if (!versi) return null;
    const baris = barisButir(versi);
    const opsi = { ...OPSI_TB_BAWAAN, ...(versi.opsi_tb || {}) }; // V1 tanpa field = bawaan (TB aktif)
    return (
        <div className="space-y-4" data-testid="survei-isi-versi">
            <div className="flex flex-wrap items-center gap-2 text-sm">
                <span className="font-semibold text-slate-800">{versi.nama}</span>
                <Badge variant="outline">{LABEL_STATUS_VERSI[versi.status] || versi.status}</Badge>
                {versi.terkunci && versi.status !== "terkunci" && (
                    <Badge variant="outline" data-testid="survei-versi-terkunci">Tidak bisa diubah (sudah dipakai)</Badge>
                )}
                <span className="text-slate-500">
                    {baris.length} butir · skala {versi.skala?.min}–{versi.skala?.max} · Puas bila rata-rata ≥ {versi.ambang_puas}
                    {" · "}<span data-testid="survei-isi-versi-tb">{opsi.aktif ? `Opsi ${opsi.label} aktif (${baris.filter((b) => b.boleh_tb !== false).length} butir boleh ${opsi.label})` : "Opsi TB nonaktif"}</span>
                </span>
            </div>
            <div className="flex flex-wrap gap-2 text-xs text-slate-600" data-testid="survei-versi-dimensi">
                {ringkasDimensi(versi).map((d) => (
                    <span key={d.kode} className="rounded border border-slate-200 px-2 py-1">{d.kode} · {d.nama}: {d.jumlah} butir</span>
                ))}
            </div>
            <div className="overflow-x-auto">
                <table className="compact w-full" data-testid="survei-tabel-butir">
                    <thead className="bg-slate-100">
                        <tr className="text-left text-xs font-semibold uppercase tracking-wider text-slate-600">
                            <th className="w-12 text-center">No.</th><th className="w-40">Dimensi</th><th>Pernyataan</th>
                            <th className="w-24 text-center">Kalimat negatif</th>
                            <th className="w-20 text-center">Boleh {opsi.label}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {baris.map((b) => (
                            <tr key={b.nomor} className="border-t border-slate-200 align-top">
                                <td className="text-center tabular-nums">{b.nomor}</td>
                                <td className="text-xs text-slate-600">{b.dimensi_kode} · {b.nama_dimensi}</td>
                                <td className="whitespace-normal text-sm text-slate-800">{b.teks}</td>
                                <td className="text-center text-xs">{b.kalimat_negatif ? "Ya" : "–"}</td>
                                <td className="text-center text-xs">{opsi.aktif && b.boleh_tb !== false ? "Ya" : "–"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="space-y-1 text-sm" data-testid="survei-versi-terbuka">
                <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">Isian terbuka (tidak wajib)</div>
                {(versi.terbuka || []).map((t) => <p key={t.kode} className="text-slate-800">{t.label}</p>)}
            </div>
        </div>
    );
}
